import { isGroupTableQuery } from 'owa-group-common';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { MailSortHelper, } from 'owa-mail-list-store';
export function shouldFolderSortByRenewTime(folderId) {
    // Folder id should not be null if not in search mode
    if (!folderId) {
        throw new Error('Current folder id should not be null');
    }
    return (folderNameToId('sentitems') != folderId &&
        folderNameToId('deleteditems') != folderId &&
        folderNameToId('drafts') != folderId &&
        folderNameToId('junkemail') != folderId);
}
export default function shouldTableSortByRenewTime(tableQuery) {
    if (isGroupTableQuery(tableQuery)) {
        return false;
    }
    if (tableQuery.type == 0 /* Folder */) {
        var tableSortby = tableQuery.sortBy;
        var renewTimeSort = MailSortHelper.getSortBySupportingPin();
        return (tableSortby.sortColumn == renewTimeSort.sortColumn &&
            tableSortby.sortDirection == renewTimeSort.sortDirection &&
            shouldFolderSortByRenewTime(tableQuery.folderId));
    }
    else {
        // Support pinning in search
        return tableQuery.type == 1 /* Search */;
    }
}
//# sourceMappingURL=shouldTableSortByRenewTime.js.map